import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { Button } from '../ui/Button'
import { Upload, FileText, Clock, Shield } from 'lucide-react'
import { LocalizedLink } from '../LocalizedLink'

export function QuoteCTA() {
  const { t } = useTranslation()

  const benefits = [
    { icon: FileText, text: t('home.quote.benefits.freeAnalysis') },
    { icon: Clock, text: t('home.quote.benefits.quote24h') },
    { icon: Shield, text: t('home.quote.benefits.confidentiality') },
  ]

  return (
    <Section variant="dark">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionTitle
              title={t('home.quote.title')}
              subtitle={t('home.quote.subtitle')}
              light
            />

            <ul className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3 text-gray-300">
                  <benefit.icon className="w-5 h-5 text-primary" />
                  <span>{benefit.text}</span>
                </li>
              ))}
            </ul>

            <LocalizedLink to="contacts">
              <Button size="lg" className="gap-2">
                <Upload className="w-5 h-5" />
                {t('home.quote.form.submit')}
              </Button>
            </LocalizedLink>
          </div>

          <div className="bg-white/5 rounded-lg p-8 border border-white/10">
            <div className="aspect-video bg-dark-lighter rounded-lg flex items-center justify-center">
              <img
                src="/images/general/icon_teamwork.png"
                alt="Teamwork"
                className="w-32 h-32 object-contain opacity-50"
              />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}
